import React from 'react';
import { ClassNameInterface } from '../../interfaces';

export const Tile: React.FC<ClassNameInterface> = ({ children, className }) => (
  <div className={`bg-white p-0 ${className || ''}`}>{children}</div>
);
